import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class MenuService {
  protected menuItems;
  protected subject;
  constructor() {
    this.menuItems = [];
      this.subject = new BehaviorSubject(this.menuItems);
  }

  getMenuItems() {
    return this.subject;
  }

    addMenuItems(menuItems, append = true) {
        console.log('before menuItems push', this.menuItems);
        console.log('pushing:', menuItems);
        if (append) {
            this.menuItems.push(menuItems);
        } else {
            this.menuItems.unshift(menuItems);
        }
        this.subject.next(this.menuItems);
        console.log('after menuItems push', this.menuItems);
    }

}



// WEBPACK FOOTER //
// ./src/app/menu/menu.service.ts